import { inject, Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { ConfirmDialogService } from 'src/app/shared/services/confirm-dialog.service';
import { PendingChangesComponent } from '../../types/pending-changes';

@Injectable({ providedIn: 'root' })
export class PendingChangesGuard implements CanDeactivate<PendingChangesComponent> {
    private readonly translocoService = inject(TranslocoService);
    private readonly confirmDialogService = inject(ConfirmDialogService);

    title = this.translocoService.translate('unsavedChanges');
    msg = this.translocoService.translate('unsavedChangesMsg');

    canDeactivate(component: PendingChangesComponent): boolean | Promise<boolean> {
        if (!component?.hasPendingChanges?.()) return true;

        return this.confirmDialogService.confirmDialog(this.msg, this.title);
    }
}
